export { default } from "./EditButton";
